export default {
  mapItem: {
    backgroundColor: '#f9f9f9',
    paddingLeft: '1rem',
  },
};
